module.exports = __webpack_public_path__ + "static/SFUIDisplay-Bold-548f317bb3fa541ef082229aafe9f5f4.woff2";